export class Constant {
    static readonly LOGIN_NOTIFICATION = 'login';
    static readonly LOGOUT_NOTIFICATION = 'logout';
    static readonly TICKETS_GENERATED_NOTIFICATION = 'tickets_generated';
}
